export default __webpack_public_path__ + "static/ec-12d6e2aa8e1e0bf10fc719d6d3f5c6d7.svg";